/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import TableList from "views/TableList.js";
import Userconfig from "views/User";
import Galleta from "views/Galleta";
import AddUser from "views/AddUser";
import Traffic from "views/Traffic";


var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Tabla de perfiles",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-align-left-2",
    component: TableList,
    layout: "/admin",
  },
  {
    path: "/userconfig",
    name: "Configuracion de usuario",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-badge",
    component: Userconfig,
    layout: "/admin",
  },
  {
    path: "/Galleta",
    name: "Galletas",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-badge",
    component: Galleta,
    layout: "/admin",
  },
  {
    path: "/Traffic",
    name: "Opciones de Tráfico",
    rtlName: "قائمة الجدول",
    icon: "tim-icons icon-user-run",
    component: Traffic,
    layout: "/admin",
  },
  
  
];
export default routes;
